module.exports = __webpack_public_path__ + "img/en_921_page_title_white.8a4d1192.png";